import { IRawStyle } from "@fluentui/react";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ButtonRenderProps, ContentSection, GridRow, GridColumn } from "sprint-common-web";

import { NoteResponse } from "../../../../common/api/orders-api/notes/GetNotesResponse";
import { getMiliseconds } from "../../../../common/utils/getMiliseconds";
import { useOrdersModuleApi } from "../../useOrdersModuleApi";
import { AddNoteButtonAside, AddNoteButtonAsideProps } from "./AddNoteButtonAside";
import { NoteItem } from "./NoteItem";
import { NotesList } from "./NotesList";

export interface NotesSectionProps {
    style?: IRawStyle;
}

export const NotesSection: React.FunctionComponent<NotesSectionProps> = ({ style }: NotesSectionProps) => {
    const [notes, setNotes] = useState<NoteItem[]>([]);
    const { orderId } = useParams<{ orderId: string }>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const { getOrderNotes } = useOrdersModuleApi();

    useEffect(() => {
        setIsLoading(true);
        getSortedNotes(orderId)
            .then((response) => setNotes(response))
            .finally(() => setIsLoading(false));
    }, []);

    const addNote = (note: NoteItem) => {
        setNotes([note, ...notes]);
    };

    const addNoteAsideButton: ButtonRenderProps<AddNoteButtonAsideProps> = {
        orderId,
        render: AddNoteButtonAside,
        addNote
    };

    const buttons = [addNoteAsideButton];

    const getSortedNotes = async (id: string): Promise<NoteItem[]> => {
        const notesResponse = await getOrderNotes({ orderId: id });

        const parsedNotes = notesResponse.notes.map(
            (noteResponse: NoteResponse): NoteItem => ({
                author: noteResponse.author,
                content: noteResponse.content,
                creationDate: noteResponse.creationDate
            })
        );

        return parsedNotes.sort(
            (a: NoteResponse, b: NoteResponse) => getMiliseconds(b.creationDate) - getMiliseconds(a.creationDate)
        );
    };

    return (
        <ContentSection header="Notes" buttons={buttons} isLoading={isLoading} style={style}>
            <GridRow>
                <GridColumn sm={12}>
                    <NotesList notes={notes} height={200} />
                </GridColumn>
            </GridRow>
        </ContentSection>
    );
};
